import { render, staticRenderFns } from "./BranchVideo.vue?vue&type=template&id=b6808c74&scoped=true&lang=pug"
import script from "./BranchVideo.vue?vue&type=script&lang=js"
export * from "./BranchVideo.vue?vue&type=script&lang=js"
import style0 from "./BranchVideo.vue?vue&type=style&index=0&id=b6808c74&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6808c74",
  null
  
)

export default component.exports